import PropTypes from 'prop-types'
import { useState } from 'react'
import { MenuItem, Segment, Tab } from 'semantic-ui-react'
import styled from 'styled-components'

// Took this idea from https://medium.com/serverlessguru/customizing-the-semantic-ui-react-library-with-styled-components-41cdab34be29
// Basically since styled components creates unique classes, the important tag won't impact other components
const ShorterSegment = styled(Segment)({
  margin: '0!important',
  paddingTop: '0!important'
})

const Tabs = ({ children, defaultTab = 0 }: any) => {
  const [activeTab, setActiveTab] = useState(defaultTab)

  const tabs = children
    .filter((child: any) => child != null)
    .map((child: any, idx: number) => {
      const component = <ShorterSegment basic>{child.props.children}</ShorterSegment>
      return {
        menuItem: <MenuItem key={idx}>{child.props.label}</MenuItem>,
        render: () => component
      }
    })

  return (
    <Tab
      activeIndex={activeTab}
      menu={{ secondary: true, pointing: true }}
      panes={tabs}
      onTabChange={(_, { activeIndex }) => {
        setActiveTab(activeIndex)
      }}
    />
  )
}

Tabs.displayName = 'Tabs'

Tabs.propTypes = {
  children: PropTypes.instanceOf(Array).isRequired,
  defaultTab: PropTypes.instanceOf(Number)
}

Tabs.defaultProps = {
  children: null,
  defaultTab: 0
}

export default Tabs
